import React from 'react'
import './styles.css'

import anim from "assets/nuboxi/anim.gif";

const miselect={
    /*fontSize: "14pt",*/
    /*lineHeight: "1.5",*/
    border: "1px solid #ced4da",
    borderRadius: ".25rem",
    display: "block",
    width: "100%",
    padding: ".275rem .75rem",
}

const NuLoading = (props) => {
    //const {value, onChange} = props;
    const miClassName = `loading-mask caja_horizontal ${ props.className }`;

    //----------sacamos el valor de type, por defecto es 1
    const { type = 1 } = props;

    return (
    <div >
        {/*<!-- loading -->*/}
        <div 
            className = {miClassName}
            style={{ ...props.style, display: props.show ? 'inline-flex':'none' }}>
            { type===2 &&
              <div className="loading-circle"></div>
            }
            { type===1 &&
              <img src={anim} className='logolila' alt=''/>
            }

            <h6 className="loading-content">{ props.text }</h6>
        </div>
        {/*<!-- -->*/}
    </div>
    )
};

export default NuLoading;